import React from "react";
import cx from "classnames";
var NavHelpSell = function NavHelpSell(_ref) {
  var title = _ref.title,
    href = _ref.href,
    onClick = _ref.onClick,
    type = _ref.type;
  return ["autoSlim", "autoIndexSlim", "slim", "imIndexSlim"].includes(type) ? (/*#__PURE__*/React.createElement("a", {
    className: cx("tc-top-sell", {
      "tc-top-sell-slim": ["autoSlim", "autoIndexSlim"].includes(type)
    }),
    href: href,
    target: '_blank',
    onClick: onClick,
    rel: 'noreferrer'
  }, title)) : null;
};
export default NavHelpSell;